import { Box, styled } from '@mui/material';

export const StyledContainer = styled(Box)(({ theme: { palette } }) => ({
  backgroundColor: palette.mode === 'dark' ? '#000D1A' : '#FFF',
}));
